// extracted by mini-css-extract-plugin
export default {"container":"container-bnln10ys","tabsHeader":"tabsHeader-wm3wvVog","tableContainer":"tableContainer-uEkkEAGD"};